/**
 * Calcula a diferença em dias entre a data atual e uma data inicial fornecida.
 *
 * @param {string|Date} initDate - A data inicial para calcular a diferença. Pode ser uma string representando uma data ou um objeto Date.
 * @returns {number|undefined} O número de dias entre a data atual e a data inicial. Retorna undefined se a data inicial não for fornecida.
 *
 * @example
 * // Retorna o número de dias entre a data atual e '2023-05-20'
 * const days = calculateDaysDifferenceFromNow('2023-05-20');
 *
 * @example
 * // Retorna o número de dias entre a data atual e um objeto Date
 * const days = calculateDaysDifferenceFromNow(new Date('2023-05-20'));
 */
export function calculateDaysDifferenceFromNow(initDate) {
  if (!initDate) return;

  const currentDate = new Date();
  const statusInitDate = new Date(initDate);
  const currentDateTimeInMs = currentDate.getTime();
  const statusInitDateTimeInMs = statusInitDate.getTime();
  const differenceBetweenDueDateAndNowDateInMs =
    currentDateTimeInMs - statusInitDateTimeInMs;
  const days = differenceBetweenDueDateAndNowDateInMs / 86400000;

  return Math.ceil(days);
}
